import { render, staticRenderFns } from "./tail-dialog.vue?vue&type=template&id=16389d52"
import script from "./tail-dialog.vue?vue&type=script&lang=js"
export * from "./tail-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports